import axios from 'axios';
import { toast } from 'react-toastify';
import { setCookie } from '../../api/utils';

export const LOGIN_LOADER = 'LOGIN_LOADER';
export const loginLoader = bool => ({
  type: LOGIN_LOADER,
  payload: bool,
});

export const loginFn = (obj, clearState) => {
  return async dispatch => {
    dispatch(loginLoader(true));
    let data = JSON.stringify(obj);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `/api/v1/auth/admin/login`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    };

    axios(config)
      .then(response => {
        dispatch(loginLoader(false));
        clearState();
        setCookie('token', response.data.token, 10);
        toast.success('Login Successfull');
      })
      .catch(error => {
        dispatch(loginLoader(false));
        toast.error('credientials does not match in our record');
      });
  };
};
export const INVITE_USER_LOADER = 'INVITE_USER_LOADER';
export const inviteUserLoader = bool => ({
  type: INVITE_USER_LOADER,
  payload: bool,
});
export const inviteUser = (obj, clearState) => {
  return async dispatch => {
    dispatch(inviteUserLoader(true));
    let data = JSON.stringify(obj);
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `/api/v1/auth/admin/invitation`,
      headers: {
        'Content-Type': 'application/json',
      },
      data: data,
    };

    axios(config)
      .then(response => {
        clearState();
        dispatch(inviteUserLoader(false));
        toast.success('Invitation sent');
      })
      .catch(error => {
        dispatch(inviteUserLoader(false));
        toast.error('soemthing went wrong');
      });
  };
};
export const GET_INVITED_USERS_LOADER = 'GET_INVITED_USERS_LOADER';
export const getInvitedUserLoader = bool => ({
  type: GET_INVITED_USERS_LOADER,
  payload: bool,
});
export const GET_INVITED_USERS = 'GET_INVITED_USERS';
export const getInvitedUserList = data => {
  return {
    type: GET_INVITED_USERS,
    payload: data,
  };
};
export const getInvitedUsers = () => {
  return async dispatch => {
    dispatch(getInvitedUserLoader(true));
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `/api/v1/auth/admin/getInvitedUsers`,
      headers: {
        'Content-Type': 'application/json',
      },
    };

    axios(config)
      .then(response => {
          dispatch(getInvitedUserList(response.data.users));
        dispatch(getInvitedUserLoader(false));
      })
      .catch(error => {
        dispatch(getInvitedUserLoader(false));
        toast.error('soemthing went wrong');
      });
  };
};
